import getConfig from "next/config";

var CONSTANTS = {
    TWITTER_MAX_CHARS: 280,
    TWITTER_DEFAULT_WEIGHTED_LENGTH: 200,
    FACEBOOK_MAX_CHARS: 1000,

    GRABYO_DOMAIN: `grabyo.com`,
    GRABYO_CLOUD_DOMAIN: `grabyocloud.com`,
    DEFAULT_API_PATH: `/api/v1`,

    TWITTER_LINK_LENGTH: 23,
    TWITTER_NON_WHITELIST_LIMIT: 140000,
    TWITTER_WHITELIST_LIMIT: 600000,
    TWITTER_MAX_BLACKLIST_CATEGORY_LIMIT: 26,
    TWITTER_CHAR_RANGES: [
        { start: 0, end: 4351, weight: 100 },
        { start: 8192, end: 8205, weight: 100 },
        { start: 8208, end: 8223, weight: 100 },
        { start: 8242, end: 8247, weight: 100 },
        { start: 65312, end: 65312, weight: 100 } // hack with the "＠" vs "@" in the mentions
    ],
    TWITTER_TITLE_LENGTH: 70,
    TWITTER_DESCRIPTION_LENGTH: 200,
    DEFAULT_TITLE_LENGTH: 100,
    DEFAULT_DESCRIPTION_LENGTH: 1000,

    PLATFORM_DEFAULT_FRAME_RATE: 25,
    PLATFORM_DEFAULT_VERTICAL_RESOLUTION: 720,

    GRAB_ORIGIN_DEVICE_TYPE: {
        IOS: `iOS`,
        ANDROID: `Android`
    },

    STREAM_TYPE: {
        PUSH_STREAM: `push`,
        PULL_STREAM: `pull`
    },

    COMPOUND_ID_DELIMITER: `:`,
    // FACEBOOK AD BREAK
    FB_FAILURE_REASON_NONE: `NONE`,
    FB_FAILURE_REASON_NOT_LIVE: `NOT_LIVE`,
    FB_FAILURE_REASON_NOT_ELIGIBLE: `NOT_ELIGIBLE`,
    FB_FAILURE_REASON_NOT_ONBOARDED: `NOT_ONBOARDED`,
    FB_FAILURE_REASON_HAS_NOT_REACHED_MIN_VIEWERS_FOR_AD_BREAK: `HAS_NOT_REACHED_MIN_VIEWERS_FOR_AD_BREAK`,
    FB_FAILURE_REASON_NOT_ENOUGH_TIME_BETWEEN_LAST_AD_BREAK: `NOT_ENOUGH_TIME_BETWEEN_LAST_AD_BREAK`,
    FB_FAILURE_REASON_BROADCASTER_VIOLATIONS: `BROADCASTER_VIOLATIONS`,
    FB_FAILURE_REASON_NOT_ENOUGH_TIME_PAST_SINCE_BROADCAST_START: `NOT_ENOUGH_TIME_PAST_SINCE_BROADCAST_START`,

    AD_BREAK_STATUS_NOT_READY: `not_ready`,
    AD_BREAK_STATUS_FETCH_READY: `fetch_ready`,
    AD_BREAK_STATUS_FETCHING: `fetching`,
    AD_BREAK_STATUS_AD_READY: `ad_ready`,

    TIMELINE_DURATION_BUFFER: 60000,

    TIMELINE_HANDLE_MODE: {
        SINGLE: `single`,
        DOUBLE: `double`
    },

    TIMELINE_SELECTION_MIN: {
        CLIP: 1000,
        GIF: 400,
        DEFAULT: 1000
    },

    TIMELINE_SELECTION_MAX: {
        GIF: 7000,
        CLIP: 14400000,
        DEFAULT: 7000
    },

    PROXY_PROTOCOL: `https:`,
    PROXY_HOST: `mediaproxy1.grabyo.com`,
    PROXY_HOST_HEADER: `X-Grabyo-Forward-Host`,
    PROXY_PORT_HEADER: `X-Grabyo-Forward-Port`,
    CUSTOM_FONT_STYLESHEET: `/api/v1/preferences/fonts/stylesheet`,
    CUSTOM_FONT_DEFAULT: `Helvetica`,
    PLATFORMS: [
        `facebook`,
        `twitter`,
        `youtube`,
        `instagram`,
        `brightcove`,
        `spredfast`,
        `theplatform`,
        `periscope`,
        `tiktok`,
        `snapchat`,
        `ftp`,
        `s3`,
        `twitch`,
        `google_cloud_platform`,
        `threads`
    ],
    PLATFORMS_GIF: [`facebook`, `twitter`, `spredfast`, `comcast`, `instagram`],
    GRABYO_GALLERY: `grabyo:gallery`,
    FOUR_HOURS_MS: 14400000,

    GRABYO_RED: `#f03f55`,
    CDN_URL: `https://dwo3ckksxlb0v.cloudfront.net`,
    PROCESSING_CLIP_VIDEO: `https://dwo3ckksxlb0v.cloudfront.net/clips/grabyostudio/processing_clip_160513.mp4`,

    DEFAULT_PLAYBACK_SPEED: 1,

    //REGEX
    REGEX_FTP_HOST: /^s?ftp:\/\//,
    REGEXP_ALPHANUMERIC_DASH_UNDERSCORE: /^[a-zA-Z0-9_-]+$/,
    REGEX_IP_WITH_OPTIONAL_SUBNET_MASK:
        /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\/([0-9]|1[0-9]|2[0-9]|3[0-2]))?$/,
    REGEX_IP_ADDRESS:
        /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,

    // TIME in milliseconds
    FIFTEEN_MINUTES: 15 * 60 * 1000,
    THIRTY_MINUTES: 30 * 60 * 1000,
    FOUR_HOURS_MINUTES: 4 * 60,
    THIRTY_SECONDS: 30 * 1000,
    TEN_SECONDS: 10 * 1000,
    FIVE_SECONDS: 5 * 1000,
    ONE_MINUTE_MILLISECONDS: 60 * 1000,
    ONE_HOUR_MILLISECONDS: 60 * 60 * 1000,
    FOUR_HOURS_MILLISECONDS: 4 * 60 * 60 * 1000,
    ONE_DAY_MILLISECONDS: 24 * 60 * 60 * 1000,
    ONE_WEEK_MILLISECONDS: 7 * 24 * 60 * 60 * 1000,
    ONE_MONTH_MILLISECONDS: 30 * 24 * 60 * 60 * 1000,
    ONE_YEAR_MILLISECONDS: 365 * 24 * 60 * 60 * 1000,
    END_OF_THE_WORLD: 32503636799000,
    HIGH_SURROGATE_LOW_LIMIT: 55296,
    HIGH_SURROGATE_HIGH_LIMIT: 56319,
    LOW_SURROGATE_LOW_LIMIT: 56320,
    LOW_SURROGATE_HIGH_LIMIT: 57343,

    // TIME in seconds
    ONE_HOUR_SECONDS: 60 * 60,
    ONE_DAY_SECONDS: 24 * 60 * 60,

    // CALENDAR
    DAYS: [`Sun`, `Mon`, `Tue`, `Wed`, `Thu`, `Fri`, `Sat`],
    MONTHS: [
        `Jan`,
        `Feb`,
        `Mar`,
        `Apr`,
        `May`,
        `Jun`,
        `Jul`,
        `Aug`,
        `Sep`,
        `Oct`,
        `Nov`,
        `Dec`
    ],
    MONTHS_FULL: [
        `January`,
        `February`,
        `March`,
        `April`,
        `May`,
        `June`,
        `July`,
        `August`,
        `September`,
        `October`,
        `November`,
        `December`
    ],

    MONTHS_LONG: [
        `January`,
        `February`,
        `March`,
        `April`,
        `May`,
        `June`,
        `July`,
        `August`,
        `September`,
        `October`,
        `November`,
        `December`
    ],

    INTEGRATIONS: {
        GRABYO: {
            TWITCH: `https://grabyo-producer-apps-prod.s3-eu-west-1.amazonaws.com/twitch-embedded-player/twitch.html`,
            TEXT_OVERLAY: `https://producer-web-sources.grabyo.com/apps/text-source/index.html`,
            OPEN_CAPTIONS: `https://producer-web-sources.grabyo.com/apps/open-captions/index.html`,
            THREADS: `https://producer-web-sources.grabyo.com/apps/threads/index.html`
        },
        SINGULAR: {
            ADD_SOURCE_IFRAME_URL: `https://app.singular.live/users/loginjwt?redirect_uri=https://app.singular.live/externals/browser%3Ftype=ai&response_type=code&client_id=grabyo`
        },
        FLOWICS: {
            ADD_SOURCE_IFRAME_URL: `https://engage.flowics.com/i/grabyo/add-source`
        },
        NEVERNO: {
            ADD_SOURCE_IFRAME_URL: `https://genericgrabyologin.dizplai.com/grabyo/add-ws`
        }
    },

    //Producer constants
    PRODUCER_COORDINATES_FLOATING_POINT_PRECISION: 10,
    PRODUCER_MAX_LAYERS: 3,
    PRODUCER_GUEST_URL: `https://guest.grabyo.com`,
    PRODUCER_MAX_GUESTS: 4,
    PRODUCER_SOURCE_TYPES: [
        `guest`,
        `live`,
        `vod`,
        `local`,
        `playlist`,
        `image`,
        `web`,
        `gif`
    ],
    RECORDING_END_TIME_ADDITION_MS: 14400000,
    POSITION: {
        TOP_LEFT: `topLeft`,
        TOP: `top`,
        TOP_RIGHT: `topRight`,
        LEFT: `left`,
        MIDDLE: `middle`,
        RIGHT: `right`,
        BOTTOM_LEFT: `bottomLeft`,
        BOTTOM: `bottom`,
        BOTTOM_RIGHT: `bottomRight`
    },

    CAPTIONS: {
        MAX_CUE_DURATION: 15000
    },

    ASPECT_RATIO_2_1_STRING: `2:1`,
    ASPECT_RATIO_16_9_STRING: `16:9`,
    ASPECT_RATIO_1_1_STRING: `1:1`,
    ASPECT_RATIO_9_16_STRING: `9:16`,
    ASPECT_RATIO_4_5_STRING: `4:5`,

    // GIF
    DEFAULT_MAX_GIF_DURATION: 7000,

    // https://en.wikipedia.org/wiki/List_of_file_signatures
    MAGIC_NUMBERS: [
        { type: `gif`, header: `47494638` },
        { type: `jpg`, header: `FFD8FFE0` },
        { type: `png`, header: `89504e47` }
    ],
    // These are not in use anywhere?
    VIDEO_MAX_SIZE: 5 * 1024 * 1024 * 1024,
    IMAGE_MAX_SIZE: 5 * 1024 * 1024,
    GIF_MAX_SIZE: 15 * 1024 * 1024,

    // MONETIZATION

    TWITTER_PRO_MEDIA_API_FEATURES: {
        MEDIATOOL_MONETIZATION_USER: `mediatool_monetization_user`,
        MEDIATOOL_AMPLIFY_DIRECT: `mediatool_amplify_direct`,
        MEDIATOOL_UPLOAD_LONG: `mediatool_upload_long`
    },

    TWITTER_MONETIZATION: {
        OPEN: `open`,
        CUSTOM: `custom`,
        VIDEO_ADS: `videoAds`,
        SPONSORSHIPS: `sponsorships`,
        CARDS: `cards`,
        NONE: `none`
    },

    YOUTUBE_MONETIZATION: {
        NONE: `none`,
        CONTENT_ID: `contentId`
    },

    THREADS: {
        MAX_CHARS: 500,
        MAX_FILE_DURATION: 300000,
        MAX_COUNTRIES: 100,
        ERRORS: {
            FILE_DURATION: `To upload to Threads the video must be under 5 minutes`,
            MAX_COUNTRIES: `You cannot geo-gate more than 100 countries when sharing to Threads. Please choose a different Campaign or reduce the number of countries.`
        }
    },

    TIKTOK: {
        MIN_FILE_DURATION: 3000,
        MAX_FILE_DURATION: 180000,
        MAX_FILE_SIZE: 4294967296,
        MIN_RESOLUTION: 540,
        ERRORS: {
            FILE_SIZE: `To upload to TikTok the video must be under 4GB`,
            FILE_DURATION: `To upload to TikTok the video must be over 3 seconds and under 3 minutes`,
            RESOLUTION: `To upload to TikTok the video resolution must be 540p or greater`
        }
    },

    INSTAGRAM: {
        IMAGE: {
            MAX_FILE_SIZE: 8000000,
            MIN_WIDTH: 320,
            MAX_WIDTH: 1440,
            ERRORS: {
                FILE_SIZE: `Images over 8MB cannot be shared to Instagram`,
                ASPECT_RATIO: `Images must have an aspect ratio of 4:5, 1:1, or 16:9 to be shared to Instagram`,
                FILE_FORMAT: `Images must be JPG in order to be shared to Instagram`
            }
        },
        GIF: {
            ERROR: `Cannot share images or GIFs to Instagram`
        },
        CLIP: {
            MAX_FILE_DURATION: 900000,
            MIN_FILE_DURATION: 3000,
            MAX_FILE_SIZE: 300000000,
            ERRORS: {
                FILE_DURATION: `To upload a clip to Instagram its duration must be over 3 seconds and under 15 minutes`,
                FILE_SIZE: `To upload a clip to Instagram it must be under 300MB`,
                ASPECT_RATIO: `Videos must be an aspect ratio of 4:5, 16:9 or 1:1 to be shared to Instagram`
            }
        },
        REEL: {
            MIN_FPS: 23,
            MAX_FPS: 60,
            MAX_FILE_DURATION: 900000,
            MIN_FILE_DURATION: 3000,
            MAX_FILE_SIZE: 300000000,
            ERRORS: {
                FILE_DURATION: `To upload a clip to Instagram Reels its duration must be over 3 seconds and under 15 minutes`,
                FILE_SIZE: `To upload a clip to Instagram Reels it must be under 300MB`,
                ASPECT_RATIO: `Videos must be an aspect ratio of 4:5, 16:9, 1:1 or 9:16 to be shared to Instagram reels`
            }
        },
        STORY: {
            MIN_FPS: 23,
            MAX_FPS: 60,
            MAX_FILE_DURATION: 60000,
            MIN_FILE_DURATION: 3000,
            MAX_FILE_SIZE: 100000000,
            ERRORS: {
                FILE_DURATION: `To upload a clip to Instagram Stories its duration must be over 3 seconds and under 60 seconds`,
                FILE_SIZE: `To upload a clip to Instagram Stories it must be under 100MB`,
                ASPECT_RATIO: `Videos must be an aspect ratio of 4:5, 16:9, 1:1 or 9:16 to be shared to Instagram Stories`
            }
        }
    },

    INSTAGRAM_OPTIONS: {
        FEED: `feed`,
        REEL: `reel`,
        STORY: `story`
    },

    FACEBOOK: {
        ADVANCED_OPTIONS: {
            NO_STORY: "facebookNoStoryVideo",
            SECRET: "facebookSecretVideo",
            DRAFT: "facebookDraft",
            NONE: "none"
        }
    },

    TWITTER: {
        ERRORS: {
            FILE_DURATION: `The clip cannot be longer than 2 mins 20 sec for standard X (Twitter) accounts and 10 mins for X (Twitter) accounts on the allowed list`,
            GEO_TARGETING: `X (Twitter) does not support geo-targeting for GIFs and images. Selected assets will be shared to X (Twitter) without any geo-targeting.`
        }
    },

    TWITTER_CARDS: {
        MAX_FILE_DURATION: 140000,
        MAX_FILE_SIZE: 100000000,
        ERRORS: {
            GIF: `The asset must be either an image or video when using Single Media Format`,
            FILE_SIZE: `The asset cannot be larger than 1GB when using Single Media Format`,
            ASPECT_RATIO: `The asset must have an aspect ratio of 16:9 or 1:1 when using Single Media Format`,
            FILE_DURATION: `The asset cannot be longer than 2 mins 20 sec when using Single Media Format`
        }
    },

    ALERT_TYPE: {
        WARN: `warn`,
        MESSAGE: `message`,
        SUCCESS: `success`,
        ERROR: `error`
    },

    // MEDIA
    MEDIA_CROPPING_PROPERTY: {
        CROP: `crop`,
        PAD: `pad`
    },
    MEDIA_TYPE: {
        CLIP: `clip`,
        GIF: `gif`,
        IMAGE: `image`,
        AUDIO: `audio`,
        VIDEO: `video`,
        VOD: `vod`,
        TEMPLATE: `template`,
        CAPTION: `captions`
    },
    MEDIA_ASPECT_RATIO: {
        SQUARE: `1:1`,
        HORIZONTAL: `16:9`,
        VERTICAL: `9:16`,
        VIDEO360: `2:1`,
        SOCIAL: `4:5`
    },
    DEFAULT_ASPECT_RATIO: `16:9`,
    PRESETS: {
        CUSTOM: `custom`,
        DEFAULT: `default`,
        CUSTOM_MAX: 50
    },
    FTP_PROTOCOL: {
        FTP: `FTP`,
        SFTP: `SFTP`,
        FTPS: `FTPS`
    },
    PORT_NUMBER: {
        FTP: 21,
        SFTP: 22,
        FTPS: 990,
        MAX_PORT: 65535,
        MIN_PORT: 1
    },

    HTTP_STATUS_CODES: {
        CONTINUE: 100,
        SWITCHING_PROTOCOLS: 101,
        OK: 200,
        CREATED: 201,
        ACCEPTED: 202,
        NON_AUTHORITATIVE_INFORMATION: 203,
        NO_CONTENT: 204,
        RESET_CONTENT: 205,
        PARTIAL_CONTENT: 206,
        MULTIPLE_CHOICES: 300,
        MOVED_PERMANENTLY: 301,
        FOUND: 302,
        SEE_OTHER: 303,
        NOT_MODIFIED: 304,
        USE_PROXY: 305,
        TEMPORARY_REDIRECT: 307,
        BAD_REQUEST: 400,
        UNAUTHORIZED: 401,
        PAYMENT_REQUIRED: 402,
        FORBIDDEN: 403,
        NOT_FOUND: 404,
        METHOD_NOT_ALLOWED: 405,
        NOT_ACCEPTABLE: 406,
        PROXY_AUTHENTICATION_REQUIRED: 407,
        REQUEST_TIMEOUT: 408,
        CONFLICT: 409,
        GONE: 410,
        LENGTH_REQUIRED: 411,
        PRECONDITION_FAILED: 412,
        REQUEST_ENTITY_TOO_LARGE: 413,
        REQUEST_URI_TOO_LONG: 414,
        UNSUPPORTED_MEDIA_TYPE: 415,
        REQUESTED_RANGE_NOT_SATISFIABLE: 416,
        EXPECTATION_FAILED: 417,
        UNPROCESSABLE_ENTITY: 422,
        TOO_MANY_REQUESTS: 429,
        INTERNAL_SERVER_ERROR: 500,
        NOT_IMPLEMENTED: 501,
        BAD_GATEWAY: 502,
        SERVICE_UNAVAILABLE: 503,
        GATEWAY_TIMEOUT: 504,
        HTTP_VERSION_NOT_SUPPORTED: 505
    },
    SORT_ORDER_ASCENDING: `asc`,
    SORT_ORDER_DESCENDING: `desc`,
    ASSET_UPLOAD_STATUS: {
        COMPLETE: `complete`,
        FAILED: `failed`,
        PROCESSING: `processing`,
        SUCCESSFUL: `successful`,
        WAITING: `waiting`
    },
    BADGE_TYPE: {
        SUCCESS: `success`,
        WARNING: `warning`,
        ERROR: `error`,
        LIVE: `live`,
        ACTIVE: `active`,
        PENDING: `pending`,
        INACTIVE: `inactive`,
        INFO: `info`
    },
    UPLOAD_TYPE: {
        DEFAULT: `default`,
        MEZZANINE: `mezzanine`
    },
    CUE_ACTIONS_DIRECTIONS: {
        UP: `up`,
        DOWN: `down`,
        LEFT: `left`,
        RIGHT: `right`
    },
    TIMELINE: {
        SNAP_RANGE_PX: 15
    },
    MOMENT_TIME_FORMATS: {
        HOURS_NO_MS: `HH:mm:ss`,
        HOURS: `HH:mm:ss.SSS`,
        MINUTES: `mm:ss.SSS`,
        SECONDS: `ss.SSS`
    },
    ONE_HOUR_IN_SECONDS: 3600,
    AUTOMATION_TYPE: {
        INACTIVE: `inactive`,
        ACTIVE: `active`,
        INPROGRESS: `in-progress`,
        UPCOMING: `upcoming`,
        COMPLETE: `complete`
    },

    ITEM_SELECTION: {
        LIST_ROW_HEIGHT: 100,
        GRID_ROW_HEIGHT: 168,
        MAX_COLUMN_NUMBER: 4,
        MAX_COLUMN_WIDTH: 400,
        MIN_COLUMN_WIDTH: 284,
        DOMAINS: {
            EDITOR: `editor`,
            PRODUCER: `producer`,
            CLIPPER: `live clipping`,
            CAMPAIGN: `campaign`
        },
        TYPE: {
            PROJECT: `projects`,
            STREAM: `streams`,
            CAMPAIGN: `campaigns`
        }
    },

    uploadStatusTypes: {
        UPLOADING: `uploading`,
        UPLOADED: `complete`,
        FAILED: `failed`,
        CANCELLED: `cancelled`,
        INVALID: `invalid`,
        VALIDATING: `validating`,
        VALID: `valid`,
        WAITING: `waiting`
    },

    BROADCAST_STATUS: {
        CREATED: `created`,
        LIVE_STARTING: `live_starting`,
        LIVE: `live`,
        LIVE_STOPPING: `live_stopping`,
        COMPLETE: `complete`,
        ERROR: `error`,
        CANCELLED: `cancelled`
    },

    SOCIAL_CREDENTIAL_STATUS: {
        ACTIVE: `active`,
        INVALID: `invalid`,
        DEACTIVATED: `deactivated`,
        DELETED: `deleted`
    },

    SOCIAL_CREDENTIAL_FEATURES: {
        MONETIZATION: `Monetization`,
        SINGLE_MEDIA_FORMAT: `Single Media Format`,
        CONTENT_ID: `Content ID`
    },

    UDVR_ELASTIC_ENCODE_STATE: {
        INITIALISING: `initialising`,
        CREATING: `creating`,
        RUNNING: `running`,
        TERMINATING: `terminating`,
        TERMINATED: `terminated`
    },

    /**
     * BROADCAST_DATA_TYPES are similar to CREDENTIAL_TYPES but vary slightly
     * and are used at different levels of the Broadcast response object. i.e.
     * <Broadcast> {
     *    braodcastData: [
     *      {
     *        type: <BROADCAST_DATA_TYPE>
     *        credential: {
     *          credentialType: <CREDENTIAL_TYPE>
     *        }
     *      }
     *    ]
     *  }
     */
    BROADCAST_DATA_TYPES: {
        FACEBOOK: `facebook`,
        TWITCH: `twitch`,
        TWITTER: `twitter`,
        PERISCOPE: `periscope`,
        YOUTUBE: `youtube`,
        INSTAGRAM: `instagram`,
        TIKTOK: `tiktok`,
        SNAPCHAT: `snapchat`,
        THEPLATFORM: `theplatform`,
        COMCAST: `theplatform`,
        FTP: `ftp`,
        BRIGHTCOVE: `brightcove`,
        SPREDFAST: `spredfast`,
        KHOROS: `spredfast`,
        S3: `s3`,
        CUSTOM_RTMP: `customrtmp`,
        AKAMAI_CUSTOM_RTMP: `customrtmp`
    },

    CREDENTIAL_TYPES: {
        AKAMAI_CUSTOM_RTMP: `akamai_custom_rtmp`,
        BRIGHTCOVE: `brightcove`,
        CUSTOM_RTMP: `custom_rtmp`,
        FTP: `ftp`,
        INSTAGRAM: `instagram`,
        OPTA: `opta`,
        SPREDFAST: `spredfast`,
        KHOROS: `spredfast`,
        PERISCOPE: `periscope`,
        S3: `s3`,
        SNAPCHAT: `snapchat`,
        THEPLATFORM: `theplatform`,
        COMCAST: `theplatform`,
        TIKTOK: `tiktok`,
        TWITCH: `twitch`,
        TWITTER: `twitter`,
        YOUTUBE: `youtube`,
        FACEBOOK: `facebook_page`,
        GLOBO: `globo`,
        GOOGLE_CLOUD_PLATFORM: "google_cloud_platform",
        THREADS: `threads`
    },

    CREDENTIAL_TYPE_LABELS: {
        FACEBOOK: `Facebook`,
        TWITCH: `Twitch`,
        TWITTER: `X (Twitter)`,
        PERISCOPE: `Periscope`,
        YOUTUBE: `Youtube`,
        INSTAGRAM: `Instagram`,
        TIKTOK: `TikTok`,
        SNAPCHAT: `Snapchat`,
        THEPLATFORM: `Comcast Technology Solutions`,
        COMCAST: `Comcast Technology Solutions`,
        AKAMAI_CUSTOM_RTMP: `Akamai Custom RTMP`,
        BRIGHTCOVE: `Brightcove`,
        CUSTOM_RTMP: `Custom RTMP`,
        FTP: `FTP`,
        OPTA: `Opta`,
        SPREDFAST: `Spredfast`,
        KHOROS: `Khoros`,
        S3: `S3`,
        GLOBO: `Globo`,
        GOOGLE_CLOUD_PLATFORM: "Google Cloud Storage",
        THREADS: `Threads`
    },

    PLATFORM_TYPES: {
        FACEBOOK: `Facebook Page`,
        TWITCH: `Twitch user`,
        TWITTER: `X (Twitter) user`,
        PERISCOPE: `Periscope account`,
        YOUTUBE: `YouTube Channel`,
        INSTAGRAM: `Instagram user`,
        TIKTOK: `Tiktok user`,
        SNAPCHAT: `Snapchat user`,
        THEPLATFORM: `Comcast Technology Solutions account`,
        FTP: `Ftp account`,
        BRIGHTCOVE: `Brightcove account`,
        OPTA: `Opta account`,
        KHOROS: `Khoros account`,
        S3: `S3 account`,
        CUSTOM_RTMP: `Custom RTMP user`,
        AKAMAI_CUSTOM_RTMP: `Akamai Custom RTMP`,
        THREADS: `Threads account`
    },

    BROADCAST_DEFAULT_EVENT: `EVENT`,

    INGEST_TYPES: {
        PRO: `pro`,
        STANDARD: `standard`
    },

    USER_ROLES: {
        USER: `USER`,
        MANAGER: `MANAGER`,
        ADMIN: `ADMIN`
    },

    USER_STATUS: {
        INACTIVE: `inactive`,
        ACTIVE: `active`,
        DEACTIVATED: `deactivated`,
        PENDING_INVITE: `pending_invite`,
        LOCKED: `locked`,
        DELETED: `deleted`
    },

    BACKBONE_EVENTS: {
        ADD: `add`,
        REMOVE: `remove`,
        MERGE: `merge`,
        UPDATE: `update`,
        RESET: `reset`,
        SORT: `sort`,
        CHANGE: `change`,
        DESTROY: `destroy`,
        REQUEST: `request`,
        SYNC: `sync`,
        ERROR: `error`,
        INVALID: `invalid`,
        ROUTE: `route`,
        ALL: `all`
    },

    MST_EVENTS: {
        ADD: `add`,
        REMOVE: `remove`,
        REPLACE: `replace`
    },

    STREAM_SCHEDULES: {
        WARNING: {
            FOUR_HOUR_LIMIT:
                "This schedule exceeds our 4-hour clipping limit. If selected, please specify the desired time period.",
            SCHEDULE_IN_FUTURE:
                "This schedule is in the future. You can view the schedule once it's live."
        }
    },

    SLIDER_CONSTANT: 8600,
    STREAM_SCHEDULE_CALENDAR: {
        DEFAULT_FIRST_DAY_OF_WEEK: 1,
        DEFAULT_VIEW: `timeGridWeek`,
        DEFAULT_EVENT_COLOR: `#5ACBFF`,
        DEFAULT_INITIAL_DATE: new Date()
    }
};

const DEV_CONSTANTS = {
    CDN_URL: `https://static.grbydv.com`,
    PRODUCER_GUEST_URL: `https://guest.grbydv.com`
};

CONSTANTS = Object.assign(CONSTANTS, {
    SUPPORTED_ASPECT_RATIOS: [
        CONSTANTS.ASPECT_RATIO_2_1_STRING,
        CONSTANTS.ASPECT_RATIO_16_9_STRING,
        CONSTANTS.ASPECT_RATIO_1_1_STRING,
        CONSTANTS.ASPECT_RATIO_9_16_STRING,
        CONSTANTS.ASPECT_RATIO_4_5_STRING
    ],
    BROADCAST_STATUS_LABEL: {
        [CONSTANTS.BROADCAST_STATUS.CREATED]: `Offline`,
        [CONSTANTS.BROADCAST_STATUS.LIVE_STARTING]: `Starting`,
        [CONSTANTS.BROADCAST_STATUS.LIVE]: `Live`,
        [CONSTANTS.BROADCAST_STATUS.LIVE_STOPPING]: `Stopping`,
        [CONSTANTS.BROADCAST_STATUS.COMPLETE]: `Complete`,
        [CONSTANTS.BROADCAST_STATUS.ERROR]: `Error`,
        [CONSTANTS.BROADCAST_STATUS.CANCELLED]: `Cancelled`
    },
    DEPRECATED_CREDENTIAL_TYPES: [CONSTANTS.CREDENTIAL_TYPES.PERISCOPE]
});

export const EVENTS = {
    CLICK: `click`,
    CONTEXT_MENU: `contextmenu`
};

export const { publicRuntimeConfig } = getConfig();

if (publicRuntimeConfig.AWS_ACCOUNT === `development`) {
    CONSTANTS = Object.assign(CONSTANTS, DEV_CONSTANTS);
}

Object.freeze(CONSTANTS);

export default CONSTANTS;
